import type { TopicResult } from './types'

/**
 * Prioritize topics where either financial or impact materiality is elevated.
 * A severe impact is not diluted by a low financial score (max-based composite).
 */
export function topicPriorityScore(topic: TopicResult): number {
  const financial = topic.financialScore
  const impact = topic.impactScore
  if (financial == null && impact == null) return -1
  if (financial == null) return impact! * 0.95
  if (impact == null) return financial * 0.9
  return Math.max(financial, impact) + Math.min(financial, impact) * 0.25
}

export function rankTopics(topics: TopicResult[]): TopicResult[] {
  const ranked = [...topics].sort((a, b) => topicPriorityScore(b) - topicPriorityScore(a))
  return ranked.map((t, index) => ({ ...t, priorityRank: index + 1 }))
}

export function topNTopics(topics: TopicResult[], n = 5): TopicResult[] {
  return rankTopics(topics)
    .filter((t) => t.financialScore != null || t.impactScore != null)
    .slice(0, n)
}
